import React from "react";
import { BsLinkedin, BsGithub } from "react-icons/bs";
import { SiTwitter, SiHashnode } from "react-icons/si";
import Image from "../assets/img1.JPG";
import "./CSS/card.css";
import "./CSS/abouts.css";

export default function About({ data }) {
  const profile = data.profile?.[0] || {};
  const baseSkills = profile.Skills ? profile.Skills.split(",").map((skill) => skill.trim()) : [];
  const skillSet = new Set(baseSkills);
  skillSet.add("Java");
  skillSet.add("Spring Boot");
  const skills = Array.from(skillSet);
  document.title = "About - Aritra";
  return (
    <div className="page container-narrow">
      <section className="section">
        <div className="about-grid">
          <div>
            <img src={Image} className="about-image" alt={profile.name || "Profile"} />
          </div>
          <div className="about-card">
            <p className="eyebrow">About me</p>
            <h2 className="section-title">{profile.name || "Your Name"}</h2>
            <p className="muted">{profile.about || "Update your profile details to share your story."}</p>
            <div className="divider"></div>
            <div>
              <p className="muted">Mail: {profile.mail || "you@example.com"}</p>
              <p className="muted">Education: {profile.college || ""}</p>
              <p className="muted">Program: {profile.curr_study || ""}</p>
              <p className="muted">CGPA: {profile.cgpa || ""}</p>
              <p className="muted">Timeline: {profile.time || ""}</p>
            </div>
            <div className="hero-social mt-3">
              <a
                href="https://www.linkedin.com/in/aritra-bhattacharjee/"
                target="_blank"
                rel="noreferrer"
              >
                <BsLinkedin />
              </a>
              <a
                href="https://github.com/AritraBhattacharjee"
                target="_blank"
                rel="noreferrer"
              >
                <BsGithub />
              </a>
              <a href="https://twitter.com/Aritra1801" target="_blank" rel="noreferrer">
                <SiTwitter />
              </a>
              <a
                href="https://hashnode.com/@AritraBhattacharjee"
                target="_blank"
                rel="noreferrer"
              >
                <SiHashnode />
              </a>
            </div>
          </div>
        </div>
      </section>

      <section className="section">
        <p className="eyebrow">Toolbox</p>
        <h2 className="section-title">Skills and technologies</h2>
        <div className="skill-chips">
          {skills.map((skill) => (
            <span className="tag" key={skill}>
              {skill}
            </span>
          ))}
        </div>
      </section>

      <section className="section">
        <p className="eyebrow">Collaboration</p>
        <h2 className="section-title">What I bring to teams</h2>
        <div className="section-grid">
          <div className="feature-card">
            <h4>Clear communication</h4>
            <p className="muted">Documentation-first mindset and regular progress updates.</p>
          </div>
          <div className="feature-card">
            <h4>Ownership mindset</h4>
            <p className="muted">I ship projects end-to-end and iterate quickly based on feedback.</p>
          </div>
          <div className="feature-card">
            <h4>Community focus</h4>
            <p className="muted">I enjoy mentoring, writing, and sharing knowledge openly.</p>
          </div>
        </div>
      </section>
    </div>
  );
}
